export var makeDeferred = function () {
    var deferred = {};
    deferred.promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
export var noop = function () { };
var HG_MEDIA_BGM_EVENT = "HG_MEDIA_BGM_EVENT";
export var dispatchBGMEvent = function (type) {
    window.dispatchEvent(new CustomEvent(HG_MEDIA_BGM_EVENT, {
        detail: {
            type: type,
        },
    }));
};
export var addBGMEventListener = function (callback) {
    window.addEventListener(HG_MEDIA_BGM_EVENT, callback);
    return function () {
        window.removeEventListener(HG_MEDIA_BGM_EVENT, callback);
    };
};
